import Grid from "@mui/material/Grid";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import AppData from "./components/data-tables/data/dataTableData";
import { useEffect } from "react";
import Header from "./components/Tabs";
import Users from "./users";
import Teams from "./teams";
import Tags from "./tags";
import Jobs from "./jobs";
import GhlFeatures from "./ghlfeatures";



function Default() {
  const onLoad = () => { };

  useEffect(onLoad, []);


  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <Grid container mt={10}>
          <Grid item xs={12}>
            <Header elements={[<Users />, <Teams />, <Tags />, <Jobs />, <GhlFeatures />]} />
          </Grid>
        </Grid>
      </DashboardLayout>
    </>
  )
}

export default Default;
